import request from '../utils/request'

export function add(object) {
  return request.post('/evaluation', object)
}

export function put(object) {
  return request.put('/evaluation', object)
}

export function list(object) {
  return request.post('/evaluation/list', object)
}

export function deleteById(id) {
  return request.delete('/evaluation/'+id)
}
